import error from '/error.png';
import { useNavigate } from 'react-router-dom';

export function FailModal() {

  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200 px-4">
      <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-lg">
        <div className="bg-red-100 p-6 rounded-lg shadow-md text-center">
          
          {/* Título */}
          <h2 className="text-2xl sm:text-3xl font-bold text-red-700 mb-6">
            Transacción Denegada
          </h2>

          {/* Imagen */}
          <div className="flex justify-center mb-6">
            <img src={error} className="w-20 sm:w-24" alt="Transacción denegada" />
          </div>

          {/* Mensaje */}
          <p className="text-gray-700 mb-8 text-base sm:text-lg">
            No ha sido posible procesar su pago. Por favor, contacte a su entidad bancaria o intente nuevamente más tarde.
          </p>

          {/* Botón */}
          <div className="flex flex-col gap-4 items-center">
            <button
              className="w-full sm:w-64 bg-gray-400 text-black py-2 rounded-lg hover:bg-gray-500 transition"
              onClick={() => navigate("/multasdetransito/")}
            >
              Volver
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}